import * as React from "react";
import UserRedirectContainer from "../../_widgets/user/UserRedirectContainer";
import User from "../../_data/models/User";

interface Props{
    user: User
};

const UserProfileHeaderComponent = (props: Props) => {    
    const {user} = props;
    return(
        <div className="row">
            <div className="large-12 columns">
                <div className="flex-container">
                    <div className="media-object">
                        <div className="media-object-section logo middle">
                            <div className="img-wrapper circle small-img-fit">
                                <p>
                                    <img width="60" src={user.profilePicture()} />
                                </p>
                            </div>
                        </div>
                        <div className="media-object-section middle">
                            <span className="h4">{user.username()}</span>
                            <p className="subheader"><small>{user.displayProfession()}</small></p>

                        </div>
                    </div>
                    <UserRedirectContainer id={user.id} element="a" className="button primary hollow small pull-right">
                        View Profile
                    </UserRedirectContainer>
                </div>
            </div>
        </div>   
    );
}

export default UserProfileHeaderComponent;


// WEBPACK FOOTER //
// ./app/client/_widgets/user/UserProfileHeaderComponent.tsx